import { render, staticRenderFns } from "./SelectIdentitiesModal.vue?vue&type=template&id=d8c0b122&scoped=true&"
import script from "./SelectIdentitiesModal.vue?vue&type=script&lang=js&"
export * from "./SelectIdentitiesModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectIdentitiesModal.vue?vue&type=style&index=0&id=d8c0b122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c0b122",
  null
  
)

export default component.exports